import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37b48173"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"overflow-y":"hidden"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ppt_con",
  style: {"height":"100vh"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "MagicPPT生成PPT的流程是：生成大纲->确认大纲->挑选模板->生成->编辑->下载（如需） 其中每执行一次流程即为1次。"),
  /*#__PURE__*/_createElementVNode("p", null, "流程开始的标志是“生成大纲”，即每生成一次大纲均会计次1次，重新生成大纲亦被认为是生成大纲，在此提请注意。建议您使用畅聊的“学术大纲生成”机器人生成大纲后再行使用。")
], -1))
const _hoisted_4 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "关于计次体系的说明",
      width: "500",
      center: "",
      style: {"border-radius":"15px"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.closeDialog,
            style: {"background":"#7733f8","border":"none"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确认 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}